export enum GoodsEnums {
  edit = 'PcbGoods/Update', // 編輯商品
  editGoodsOnOtherPool = 'PcbGoods/UpdateGoodsOnOtherPool', // 編輯商品-其他業主商品池
  add = 'PcbGoods/Add', // 新增商品
  addGoodsOnOtherPool = 'PcbGoods/AddGoodsOnOtherPool', // 新增商品-其他業主商品池
  addGoodsInSelections = 'PcbGoods/AddGoodsInSelections', // 快速新增商品（更換商品彈窗）
  delete = 'PcbGoods/Disable', // 刪除商品
  deleteOnOtherPool = 'PcbGoods/DisableOnOtherPool', // 刪除商品-其他業主商品池
  info = 'PcbGoods/GoodsOperationInfo', // 商品營運數據清單
  infoOnOtherPool = 'PcbGoods/OnOtherGoodsOperationInfo', // 商品營運數據清單-其他業主商品池
  chart = 'MachineHome/ClawOperationsInAllStoresChart' // 商品營運數據圖表
}
